<template>
  <gas-page-shell :breadcrumb="['系统设置', '操作日志']">
    <div class="log-toolbar">
      <p class="log-tip">仅展示最近 7 天的操作记录；后台会自动记录增删改等重要操作。</p>
      <el-button type="danger" plain size="small" icon="el-icon-delete" @click="clearAll">清空全部日志</el-button>
    </div>
    <el-form :inline="true" :model="query" size="small" class="search-form">
      <el-form-item label="模块"><el-input v-model="query.moduleName" clearable placeholder="模块名称" /></el-form-item>
      <el-form-item label="关键词"><el-input v-model="query.keyword" clearable placeholder="操作/操作人" /></el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetQuery(() => { query.moduleName = '' })">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="table-title-row">
      <span class="table-title">操作日志 <em>共 {{ total }} 条记录</em></span>
      <gas-table-toolbar
        :columns="tableColumnDefs"
        :visible-map.sync="tableColumnVisible"
        :selected-count="selectedIds.length"
        :show-batch-delete="tableCanBatchDelete"
        @batch-delete="batchRemove"
      />
    </div>
    <el-table :data="list" v-loading="loading" border size="small" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="44" align="center" />
      <el-table-column prop="moduleName" label="模块" min-width="120" />
      <el-table-column prop="operation" label="操作" min-width="160" show-overflow-tooltip />
      <el-table-column prop="requestMethod" label="请求方式" width="88" align="center" />
      <el-table-column prop="operatorName" label="操作人" width="100" />
      <el-table-column prop="operIp" label="IP" width="120" />
      <el-table-column label="状态" width="88">
        <template slot-scope="{ row }"><gas-status-tag kind="oper" :value="row.operStatus" /></template>
      </el-table-column>
      <el-table-column prop="operTime" label="操作时间" min-width="150" />
      <el-table-column label="操作" width="80" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" class="danger" @click="removeRow(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pager" background layout="total, sizes, prev, pager, next"
      :total="total" :current-page="query.pageNum" :page-size="query.pageSize"
      :page-sizes="[10,20,50]" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
  </gas-page-shell>
</template>

<script>
import GasPageShell from '@/components/GasPageShell.vue'
import gasCrudPage from '@/mixins/gasCrudPage'
import { gasApi } from '@/api/gas'

export default {
  components: { GasPageShell },
  mixins: [gasCrudPage],
  data() {
    return {
      idField: 'logId',
      listApi: gasApi.operLog.list,
      saveApi: null,
      removeApi: gasApi.operLog.remove,
      batchRemoveApi: gasApi.operLog.batchRemove,
      query: { pageNum: 1, pageSize: 10, keyword: '', moduleName: '' }
    }
  },
  methods: {
    async clearAll() {
      await this.$confirm('确认清空全部操作日志？此操作不可恢复。', '提示', { type: 'warning' })
      await gasApi.operLog.clearAll()
      this.$message.success('已清空全部日志')
      this.loadData()
    }
  }
}
</script>

<style scoped>
.log-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.log-tip {
  margin: 0;
  color: #86909c;
  font-size: 13px;
}
.search-form { margin-bottom:8px; }
.pager { margin-top:16px; text-align:right; }
.danger { color:#f53f3f; }
</style>
